module.exports = __webpack_public_path__ + "img/instagram.aed0df19.svg";